module.exports = __webpack_public_path__ + "static/media/accent_disable.ae680296.svg";